/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AssignAttendeeRequest} from '../models/AssignAttendeeRequest';
import type {AssignAttendeeResponse} from '../models/AssignAttendeeResponse';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';

export interface AttendeeBulkAssign$Request {
    assignAttendeeRequest: Array<AssignAttendeeRequest>;
    reason?: string;
}

export interface AttendeeBulkAssign$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const attendeeBulkAssignRequest = createAction<PayloadData<void, AttendeeBulkAssign$Request>>('BULK_ATTENDEE_ASSIGN__ATTENDEE_BULK_ASSIGN__REQUEST');
export const attendeeBulkAssignSuccess = createAction<PayloadData<string, AttendeeBulkAssign$Request>>('BULK_ATTENDEE_ASSIGN__ATTENDEE_BULK_ASSIGN__SUCCESS');
export const attendeeBulkAssignFailure = createAction<PayloadData<Error, AttendeeBulkAssign$Request, true>>('BULK_ATTENDEE_ASSIGN__ATTENDEE_BULK_ASSIGN__FAILURE');

export const attendeeBulkAssignActions = [
    attendeeBulkAssignRequest,
    attendeeBulkAssignSuccess,
    attendeeBulkAssignFailure
] as const;

/**
 * @param {Array<AssignAttendeeRequest>} meta.assignAttendeeRequest
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const attendeeBulkAssign = (meta: AttendeeBulkAssign$Request, config?: AttendeeBulkAssign$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: attendeeBulkAssignActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/bulk-actions/conferences/assign-attendees`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.assignAttendeeRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAttendeeAssignProgress$Request {
    id: string;
}

export interface GetAttendeeAssignProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAttendeeAssignProgressRequest = createAction<PayloadData<void, GetAttendeeAssignProgress$Request>>('BULK_ATTENDEE_ASSIGN__GET_ATTENDEE_ASSIGN_PROGRESS__REQUEST');
export const getAttendeeAssignProgressSuccess = createAction<PayloadData<BulkProgress, GetAttendeeAssignProgress$Request>>('BULK_ATTENDEE_ASSIGN__GET_ATTENDEE_ASSIGN_PROGRESS__SUCCESS');
export const getAttendeeAssignProgressFailure = createAction<PayloadData<Error, GetAttendeeAssignProgress$Request, true>>('BULK_ATTENDEE_ASSIGN__GET_ATTENDEE_ASSIGN_PROGRESS__FAILURE');

export const getAttendeeAssignProgressActions = [
    getAttendeeAssignProgressRequest,
    getAttendeeAssignProgressSuccess,
    getAttendeeAssignProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAttendeeAssignProgress = (meta: GetAttendeeAssignProgress$Request, config?: GetAttendeeAssignProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getAttendeeAssignProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/conferences/assign-attendees/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAttendeeAssignResult$Request {
    id: string;
}

export interface GetAttendeeAssignResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAttendeeAssignResultRequest = createAction<PayloadData<void, GetAttendeeAssignResult$Request>>('BULK_ATTENDEE_ASSIGN__GET_ATTENDEE_ASSIGN_RESULT__REQUEST');
export const getAttendeeAssignResultSuccess = createAction<PayloadData<AssignAttendeeResponse, GetAttendeeAssignResult$Request>>('BULK_ATTENDEE_ASSIGN__GET_ATTENDEE_ASSIGN_RESULT__SUCCESS');
export const getAttendeeAssignResultFailure = createAction<PayloadData<Error, GetAttendeeAssignResult$Request, true>>('BULK_ATTENDEE_ASSIGN__GET_ATTENDEE_ASSIGN_RESULT__FAILURE');

export const getAttendeeAssignResultActions = [
    getAttendeeAssignResultRequest,
    getAttendeeAssignResultSuccess,
    getAttendeeAssignResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAttendeeAssignResult = (meta: GetAttendeeAssignResult$Request, config?: GetAttendeeAssignResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getAttendeeAssignResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/conferences/assign-attendees`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface StopAttendeeAssign$Request {
    id: string;
}

export interface StopAttendeeAssign$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const stopAttendeeAssignRequest = createAction<PayloadData<void, StopAttendeeAssign$Request>>('BULK_ATTENDEE_ASSIGN__STOP_ATTENDEE_ASSIGN__REQUEST');
export const stopAttendeeAssignSuccess = createAction<PayloadData<void, StopAttendeeAssign$Request>>('BULK_ATTENDEE_ASSIGN__STOP_ATTENDEE_ASSIGN__SUCCESS');
export const stopAttendeeAssignFailure = createAction<PayloadData<Error, StopAttendeeAssign$Request, true>>('BULK_ATTENDEE_ASSIGN__STOP_ATTENDEE_ASSIGN__FAILURE');

export const stopAttendeeAssignActions = [
    stopAttendeeAssignRequest,
    stopAttendeeAssignSuccess,
    stopAttendeeAssignFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const stopAttendeeAssign = (meta: StopAttendeeAssign$Request, config?: StopAttendeeAssign$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: stopAttendeeAssignActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/bulk-actions/conferences/assign-attendees`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

